<template>
    <section class="section section-blue">
        <div class="container">
            <div class="row">
                <a class="target" aria-hidden="true" name="target" id="fleet">&nbsp;</a>
                <h2 class="section-heading section-heading-white col-12">
                    Our Fleet
                </h2>
                <div v-for="group in groupedVessels" v-bind:key="group.category"
                    class="category-wrapper col-12 col-lg-6 col-xl-3">
                    <h3 class="category-heading">{{ group.category }}</h3>
                    <div role="grid">
                        <div class="grid-header row" role="row">
                            <div class="col-12" aria-hidden="true">
                                <div class="border tick-border"></div>
                            </div>
                            <div class="col-3" role="columnheader">
                                count
                            </div>
                            <div class="col-9" role="columnheader">
                                type
                            </div>
                            <div class="col-12" aria-hidden="true">
                                <div class="border tick-border"></div>
                            </div>
                        </div>

                        <div v-for="vessel in group.types" v-bind:key="vessel.id" class="row grid-row" role="row">
                            <div class="col-3" role="gridcell">{{ vessel.count }}</div>
                            <div class="col-9" role="gridcell">{{ vessel.type }}</div>
                            <div class="col-12" aria-hidden="true">
                                <div class="border thin-border"></div>
                            </div>
                        </div>
                    </div>

                    <p class="category-total">Total {{ group.category.split(' ')[0] }}: {{ group.totalCount }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "VesselsByType",
    data() {
        return {
            currentVesselsType: "Cape",
        }
    },
    methods: {
        viewType: function (type, ev) {
            ev.preventDefault();

            this.currentVesselsType = type;
        },
    },
    computed: {
        groupedVessels() {
            var vessels = this.vessels;

            if (!vessels) {
                return [];
            }

            var grouped = [];

            for (const vessel of vessels) {
                var group = grouped.find(g => {
                    return g.category === vessel.category
                });

                if (!group || !group.types) {
                    grouped.push({
                        category: vessel.category,
                        types: [vessel],
                        totalCount: vessel.count
                    });
                } else {
                    group.types.push(vessel);
                    group.totalCount += vessel.count;
                }
            }

            return grouped.sort((a, b) => {
                if (a.category === 'Cape') {
                    return -1;
                } else if (b.category === 'Cape') {
                    return 1;
                } else {
                    if (a.category === 'Babycape and Postpanamax') {
                        return -1;
                    } else if (b.category === 'Babycape and Postpanamax') {
                        return 1;
                    } else {
                        if (a.category === 'Panamax') {
                            return -1;
                        }
                        return 1;
                    }
                }
            });
        },
        vessels() {
            return this.$store.state.vesselsByType;
        },
    }
}
</script>

<style scoped>
.category-wrapper {
    margin-bottom: 4em;
}

.category-heading {
    font-weight: 400;
    margin-bottom: 0.5em;
    display: table-cell;
    vertical-align: bottom;
}

.category-total {
    text-transform: uppercase;
    position: absolute;
    bottom: -1.5em;
    height: 0.25em;
}

.border {
    background: #FFF;
    margin: 1em auto;
    border: none !important;
}

.tick-border {
    height: 2px;
}

.thin-border {
    height: 1px;
}

.grid-header {
    text-transform: uppercase;
    font-weight: 600;
}

@media only screen and (min-width: 1200px) {
    .category-heading {
        height: 2.4em;
    }
}
</style>